<template>
  <div 
    class="container d-flex align-items-center justify-content-center"
    :class="{ 'small-height': asistenciaConfirmada || showQRCode }"
  > 
  <div class="franja-lateral">
    <i class="fas fa-envelope"></i> <!-- Ícono de email -->
    <p>Confirma tu asistencia</p>
  </div>
    <div 
      :class="{
        'overlay': true,
        'small-container': asistenciaConfirmada || showQRCode
      }"
      class="p-5 rounded-4 shadow-lg"
    >
   


      <div v-if="asistenciaConfirmada">
        <div class="qr-confirmation-container text-center">
        

          <div class="qr-content">
            <img
              v-if="qrCode"
              :src="qrCode"
              alt="Código QR"
              class="qr-image"
            >

            <p
              v-else
              class="qr-error"
            >
              No se ha generado el código QR
            </p>
          </div>
     
        

          <p class="qr-footer">
            Preséntalo el día del evento.
          </p>
        </div>
      </div>

      <div
        v-else
        class="confirmation-container"
      >



        <!-- Formulario de confirmación -->
     
        <form @submit.prevent="handleSubmit">
          <div class="form-group mb-3">
            <label
              for="name"
              class="form-label"
            ><br>Nombre</label>
            <input
              id="name"
              v-model="name"
              type="text"
              class="form-control"
              placeholder="Ingresa tu nombre"
              required
            >
          </div>

          <div class="form-group mb-3">
            <label
              for="phone"
              class="form-label"
            >Teléfono</label>
            <input
              id="phone"
              v-model="phone"
              type="tel"
              class="form-control"
              placeholder="Ingresa tu teléfono"
              required
            >
          </div>

           
           
          <div
            v-if="!isXv"
            class="form-group mb-3"
          >
            <label class="form-label">¿Invitado por?</label>
            <div class="d-flex justify-content-start gap-4">
              <div class="form-check">
                <input
                  id="novia"
                  v-model="invitedBy"
                  type="radio"
                  value="novia"
                  class="form-check-input"
                  required
                >
                <label
                  class="form-check-label"
                  for="novia"
                >Novia</label>
              </div>
              <div class="form-check">
                <input
                  id="novio"
                  v-model="invitedBy"
                  type="radio"
                  value="novio"
                  class="form-check-input"
                >
                <label
                  class="form-check-label"
                  for="novio"
                >Novio</label>
              </div>
            </div>
          </div>

          <div class="form-group mb-3">
            <label class="form-label">¿Asistirás?</label>
            <div class="d-flex justify-content-start gap-4">
              <div class="form-check">
                <input
                  id="si"
                  v-model="attending"
                  type="radio"
                  value="si"
                  class="form-check-input"
                  required
                >
                <label
                  class="form-check-label"
                  for="si"
                >Sí</label>
              </div>
              <div class="form-check">
                <input
                  id="no"
                  v-model="attending"
                  type="radio"
                  value="no"
                  class="form-check-input"
                >
                <label
                  class="form-check-label"
                  for="no"
                >No</label>
              </div>
            </div>
          </div>
          <div
            class="form-group mb-3"
          >
            <label
              for="guests"
              class="form-label"
            >¿Cuántos asisten?</label>
            <select
              id="guests"
              v-model="guests"
              class="form-select"
              :class="{ 'loading': loading }"
              :disabled="attending === 'no'"
            >
              <option value="" disabled>Selecciona una opción</option>

              <option
                v-for="n in guestsOptions"
                :key="n"
                :value="n"
              >
                {{ n }}
              </option>
              <option
                v-if="attending === 'no'"
                value="0"
              >
                0
              </option> <!-- Esta opción solo aparecerá si no asiste -->
            </select>
          </div>
  
          <button
            type="submit"
            class="btn btn-primary w-100"
          >
            Confirmar
          </button>
        </form>

        <div
          v-if="showQRCode"
          class="qr-confirmation-container text-center"
        >
          <p class="qr-title">
            <br>¡Gracias por confirmar tu asistencia!
          </p><br>
      
          <div class="qr-content">
            <img
              v-if="qrCode"
              :src="qrCode"
              alt="Código QR"
              class="qr-image"
            >
            <p
              v-else
              class="qr-error"
            >
              No se ha generado el código QR
            </p>
          </div>
        
     
   
          <p class="qr-footer">
            Preséntalo el día del evento.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
import { ref, onMounted, watch } from 'vue';
import axios from 'axios';
import baseUrl from '../api';  // Asegúrate de importar la URL base

export default {
  name: 'ConfirmacionAsistencia',
  props: {
    idInvitado: {
      type: Number,
      required: true,
      validator(value) {
        return !isNaN(value) && value > 0;
      }
    },
    nombre: {
      type: String,
      default: '',
    },
    idFestejado: {
      type: Number,
      default: null,
    }
  },
  setup(props) {
    const name = ref('');
    const phone = ref('');
    const invitedBy = ref('');
    const attending = ref('');
const guests = ref(''); // Esto muestra “Selecciona una opción” por defecto
    const guestsOptions = ref([1, 2]);  // Opciones por defecto
    const successMessage = ref('');  // Definir successMessage
    const loading = ref(true); // Estado de carga
    const isXv = ref(props.nombre === 'XV' || props.nombre === 'xv' || props.nombre === 'YM' || props.nombre === 'ym' );
    const asistenciaConfirmada = ref(false);


    const fetchGuestLimit = async () => {
      try {
        const paqueteUrl = `${baseUrl}/${props.nombre ? `${props.nombre}/` : ''}${props.idFestejado ? `${props.idFestejado}/` : ''}${props.idInvitado ? `${props.idInvitado}` : ''}`;

        const response = await axios.get(paqueteUrl); // Aquí realizas la solicitud

        const data = response.data; // Accede a los datos directamente
        const numPases = data.num_pase; // Verifica que el nombre del campo sea correcto

        if (numPases === null || numPases === 0) {
          guestsOptions.value = [1, 2];
        } else {
          guestsOptions.value = Array.from({ length: numPases }, (_, i) => i + 1);
        }
      } catch (error) {
        console.error('Error al obtener el número de pases:', error);
      } finally {
        loading.value = false; // Cambia el estado de carga
      }
    };
    
    const verificarAsistencia = async () => {
  try {
    console.log('Verificando asistencia para idInvitado:', props.idInvitado);  // Verificar si llega el idInvitado
    const response = await axios.post(`${baseUrl}/api2/verificar-asistencia`, {
      idInvitado: props.idInvitado  // Enviar el idInvitado en el cuerpo de la solicitud
    });

    // Verificar la respuesta recibida
    console.log('Respuesta recibida:', response.data);

    if (response.data.asistio) {
      asistenciaConfirmada.value = true;
      obtenerCodigoQR(); // Solo obtener QR si ya confirmó
    } else {
      asistenciaConfirmada.value = false;
    }
  } catch (error) {
    console.error('Error al verificar asistencia:', error);
  }
};


    watch(attending, (newValue) => {
      if (newValue === 'no') {
        guests.value = '0'; // Cambia automáticamente a "0" si no asistirá
      } else if (newValue === 'si' && guests.value === '0') {
        guests.value = '1'; // Restaura el valor por defecto si decide asistir
      }
    });

    onMounted(() => {
      fetchGuestLimit();
      verificarAsistencia(); // Verificar la asistencia al cargar el componente

    });








    
    const obtenerCodigoQR = async () => {
  try {
    // Verifica el ID antes de enviarlo
    const idInvitadoInt = Number(props.idInvitado);

    if (isNaN(idInvitadoInt) || idInvitadoInt <= 0) {
      console.error("ID Invitado no válido:", props.idInvitado);
      return;
    }

    console.log("Enviando ID Invitado como Integer:", idInvitadoInt);

    const response = await axios.post(`${baseUrl}/api2/codigoqrinvitado`, { 
      id_invitado: idInvitadoInt 
    });
      console.log('Respuesta de la API:', response.data);

    if (response.data && response.data.codigoqr) {
      qrCode.value = response.data.codigoqr;
    } else {
      console.error('Código QR no disponible en la respuesta');
      qrCode.value = null;
    }
  } catch (error) {
    console.error('Error obteniendo el código QR:', error);
    successMessage.value = ['¡No se pudo obtener el código QR!'];
    qrCode.value = null;
  }
};



    const handleSubmit = async () => {
      if (!name.value || !phone.value || 
          (!invitedBy.value && !isXv.value) || 
          !attending.value || !guests.value) {
        successMessage.value = ['¡Faltan datos, completa el formulario!'];
        return;
      }
      const formData = {
        nombre_asistencia: name.value,
        telefono_invitado: phone.value,
        invitedby: isXv.value ? 'novia' : invitedBy.value,
        asistira: attending.value,
        id_festejada: props.idFestejado,  // Agregar el parámetro aquí
        id_invitado: props.idInvitado,  // Agregar el parámetro aquí
        num_pases: attending.value === 'no' ? 0 : guests.value, // Set to 0 if not attending
      };

      try {
        const response = await fetch(`${baseUrl}/asistencia`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          successMessage.value = ['¡Hubo un error, intenta de nuevo!'];
          return;
        }

        successMessage.value = ['¡Confirmación exitosa!'];

        // Obtener y mostrar el código QR
        await obtenerCodigoQR();
      } catch (error) {
        successMessage.value = ['¡Intenta de nuevo!'];
        console.error('Error confirmando asistencia:', error);
      }
    };

    const qrCode = ref(null);  // Para almacenar el código QR generado
    const showQRCode = ref(false);  // Para mostrar el QR después de la confirmación

    watch(successMessage, (newMessage) => {
      if (newMessage.includes('¡Confirmación exitosa!')) {
        showQRCode.value = true;  // Mostrar QR si la confirmación es exitosa
      }
    });

    return {
      name,
      phone,
      invitedBy,
      attending,
      guests,
      guestsOptions,
      successMessage,
      loading,
      asistenciaConfirmada,

      isXv,
      handleSubmit,
      qrCode,
      showQRCode,
    };
  },
};
</script>


<style scoped>
.container {
    background-image: url('@/assets/7.png'); /* 🔹 pon tu imagen aquí */
     background-size: cover;      /* 🔹 la imagen cubre todo */
  background-position: center; /* centrada */
  background-repeat: no-repeat; /* no se repite */  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 100vh;
  padding: 0;
  box-sizing: border-box;
}

/* Contenedor principal con franja lateral */
/* Contenedor principal con franja lateral */
/* Contenedor principal */
.overlay {
  max-width: 115hv; /* Ajustado para incluir la franja */
  width: 90%;
  background: white;
  border-radius: 15px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
/* Franja lateral */
.franja-lateral {
  background: rgba(161, 151, 142, 0.95); /* Color oscuro */
  color: white;
  width: 35%; /* Ahora ocupa solo el 35% */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  text-align: center;
}

.franja-lateral i {
  font-size: 2rem;
  margin-bottom: 10px;
}

.franja-lateral p {
  font-size: 26px;
  font-weight: normal;
  line-height: 1.3;
  margin-bottom: 20px;
    color: #f1e9dc;
  font-family: 'Playfair Display', serif;
}
/* Sección del formulario */
.formulario-container {
  flex: 1; /* Hace que el formulario ocupe el espacio restante */
  padding: 40px;
  text-align: left;
}

/* Título principal */
.custom-title {
  font-size: 1.8rem;
  font-family: 'Playfair Display', serif;
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  color: #4a4a4a;
}

/* Estilos para "Acceso a niños" */
.textninos {
  font-size: 16px;
  font-weight: 600;
  background: rgba(107, 109, 72, 0.1);
  text-align: center;
  color: #735945;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 20px;
}

/* Campos del formulario */
input,
textarea,
select {
  background: rgba(255, 255, 255, 0.6);
  color: #333;
  border: 1px solid rgba(0, 0, 0, 0.3);
  padding: 10px;
  border-radius: 5px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  width: 100%;
  transition: all 0.3s ease;
}

input:focus,
textarea:focus,
select:focus {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(0, 0, 0, 0.5);
}

/* Estilos para etiquetas */
label {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: #4a4a4a;
  display: block;
  margin-bottom: 5px;
}

/* Botón de confirmación */
.btn {
  background: rgba(161, 151, 142, 0.95);  /* Color oscuro */
  color: white;
  font-family: 'padres';
  font-size: 15px;
  font-weight: 500;
  padding: 12px;
  border-radius: 6px;
  width: 100%;
  text-align: center;
  transition: all 0.3s ease-in-out;
  letter-spacing: 1px;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.btn:hover {
  background-color: #333;
  transform: scale(1.03);
}



/* Estilos para los radio buttons */
.form-check {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-check-input {
  width: 18px;
  height: 18px;
  appearance: auto;
  accent-color: #A18A68;
}

/* Ajustes para dispositivos móviles */
@media (max-width: 768px) {
  .overlay {
    flex-direction: column;
    width: 95%;
  }

  .franja-lateral {
    width: 100%;
    text-align: center;
    padding: 20px;
  }

  .formulario-container {
    width: 100%;
    padding: 30px;
  }

  .custom-title {
    font-size: 1.5rem;
  }

  .btn {
    font-size: 16px;
  }
}



.qr-confirmation-container {
  text-align: center;
  padding: 0px;
  background: rgba(255, 255, 255, 0.08);
  
}

/* ✨ Texto "¡Gracias por confirmar!" */
.qr-title {
  font-size: 18px;
  color: #354257;
  font-family: 'Karla', cursive !important;
  font-weight: 600;
  margin-bottom: 5px;
}

/* 🏷️ Texto "Tu Pase Digital" */
.qr-subtitle {
  font-size: 30px;
    font-family: 'say2';

  color: #354257;
  margin-bottom: 15px;
}

.qr-subtitle2 {
  font-size: 18px;
  color: #423645; /* 🎀 Un tono rosa elegante */
  text-shadow: 2px 2px 6px rgba(80, 83, 109, 0.4);
  font-weight: 500;
  letter-spacing: 1.5px;
  margin-top: 10px;
  text-align: center;
}


/* 📷 Imagen del QR */
.qr-content img {
  width: 180px;
  height: auto;
  margin: 15px 0;
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

/* ❌ Mensaje si no hay QR */
.qr-error {
  font-size: 16px;
  color: rgb(64, 67, 84);
  font-weight: bold;
}

/* 🖋️ Texto "Preséntalo el día del evento" */
.qr-footer {
  font-family: 'Karla';
  color: #1a1818cd;
  font-size: 18px;
  margin-top: 10px;
}


/* Imagen de la corona */
.separadorcorona {
  margin-top: 8px;

  width: auto; /* Mantiene el tamaño original */
  height: 50px; /* Ajusta el tamaño según sea necesario */
}input,
textarea,
select {
  background-color: transparent !important;
  border: none;
  border-bottom: 1px solid #2d2b2b;
  border-radius: 0;
  padding: 8px 0;
  font-size: 15px;
  color: rgb(0, 0, 0);
  font-family: 'Poppins', sans-serif;
  width: 100%;
  box-shadow: none;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-bottom: 1px solid #2d2b2b;
  background-color: transparent;
  color: rgb(17, 17, 17);
}

label {
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgb(35, 34, 34);
  font-family: 'Poppins', sans-serif;
  margin-bottom: 4px;
}
.form-group {
  margin-bottom: 20px;
}

.form-control::placeholder {
  color: rgba(10, 10, 10, 0.4);
  font-style: italic;
}
select,
select option {
  color: rgb(42, 41, 41);
}
</style>
